<!-- 会員登録ボタン -->
<template>
  <a class="crly-a-common-btn-sign-up crly-icon" @click="clickSignUpBtn">
    <div class="crly-a-common-btn-sign-up__icon crly-icon"></div>
    <span class="crly-a-common-btn-sign-up__label crly-icon-txt"></span>
  </a>
</template>

<script>
export default {
  name: "CrlyAtomsCommonBtnSignUp",
  methods: {
    clickSignUpBtn() {
      this.$emit("clickMenuBtn", false);
      this.$router.push({ name: "CrlyEntry" });
},
  },
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/btn/signUp.scss";
</style>
